import React, { useState } from "react";
import "./style.scss";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { ReactComponent as FbIcon } from "../../../assets/icons/svg/facebook.svg";
import { ReactComponent as LinkedinIcon } from "../../../assets/icons/svg/linkedin.svg";

const data = [
	{
		img: "https://i.ibb.co/KbwJtsw/Rectangle-2034.png",
		facebook: "/",
		linkedin: "/",
		name: "Deven Parulekar",
		position: "Founder",
		category: "Founders",
	},
	{
		img: "https://i.ibb.co/KbwJtsw/Rectangle-2034.png",
		facebook: "/",
		linkedin: "/",
		name: "Deven Parulekar",
		position: "Founder",
		category: "Founders",
	},
	{
		img: "https://i.ibb.co/KbwJtsw/Rectangle-2034.png",
		facebook: "/",
		linkedin: "/",
		name: "Deven Parulekar",
		position: "Founder",
		category: "Founders",
	},
	{
		img: "https://i.ibb.co/KbwJtsw/Rectangle-2034.png",
		facebook: "/",
		linkedin: "/",
		name: "Deven Parulekar",
		position: "Founder",
		category: "Founders",
	},
	{
		img: "https://i.ibb.co/KbwJtsw/Rectangle-2034.png",
		facebook: "/",
		linkedin: "/",
		name: "Deven Parulekar",
		position: "Founder",
		category: "Founders",
	},
	{
		img: "https://i.ibb.co/KbwJtsw/Rectangle-2034.png",
		facebook: "/",
		linkedin: "/",
		name: "Deven Parulekar",
		position: "Founder",
		category: "Founders",
	},
	{
		img: "https://i.ibb.co/KbwJtsw/Rectangle-2034.png",
		facebook: "/",
		linkedin: "/",
		name: "Deven Parulekar",
		position: "Founder",
		category: "Founders",
	},
];

const Team = () => {
	// var settings = {
	// 	dots: true,
	// 	infinite: true,
	// 	speed: 500,
	// 	slidesToShow: window.innerWidth < 900 ? 1 : 3,
	// 	slidesToScroll: 1,
	// 	centerMode: true,
	// };
	// const [teamCategory, setTeamCategory] = useState("");
	return (
		<div className="about-team">
			<div className="top">Our Team</div>
			<div className="bottomf">Meet the people powering SaffronStays</div>
			{/* <div className="team-wrapper">
				<Slider {...settings}>
					{data.map((ele) => {
						if (teamCategory === ele.category || teamCategory === "") {
							return <TeamCard key={ele.name} {...ele} />;
						}
						return null;
					})}
				</Slider>
			</div> */}
			<script src="https://apps.elfsight.com/p/platform.js" defer></script>
			<div
				class="elfsight-app-3c0d7209-b061-4d4a-99cd-1abc81699bcf"
				style={{ marginTop: "60px" }}
			></div>
		</div>
	);
};

const TeamCard = ({ img, facebook, linkedin, name, position, category }) => {
	return (
		<div className="team-card-wrapper">
			<img src={img} alt={name} />
			<div className="team-card-detail">
				<h3>{name}</h3>
				<h4>{position}</h4>
				<div
					style={{
						gap: "10px",
						display: "flex",
					}}
				>
					{facebook && (
						<a href={facebook} id="social-link-fb" className="social-link">
							<FbIcon />
						</a>
					)}
					{linkedin && (
						<a
							href={linkedin}
							id="social-link-linkedin"
							className="social-link"
						>
							<LinkedinIcon />
						</a>
					)}
				</div>
			</div>
		</div>
	);
};

export default Team;
